export default "__VITE_ASSET__CSXipurU__"